export default __webpack_public_path__ + "static/media/CNo.36-1.70a77936.jpg";